import styled from 'styled-components'

export const Container = styled.div`
  h1 {
    font: normal normal bold 20px/24px Inter;
    letter-spacing: 0px;
    color: ${props => props.theme.colors.color2d3139};
    padding-bottom: 20px;
    border-bottom: 1px solid #9eadbf;
  }
`

export const ContainerTable = styled.div`
  position: relative;
  padding: 16px 12px;
  width: 100%;
  display: flex;
  flex-flow: column;
  flex: 1 1 auto;
  overflow: hidden;
  max-height: 60vh;

  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
`

export const TableFiltersHeader = styled.div`
  position: relative;
  margin-bottom: 15px;
  flex: 0 1 auto;

  display: grid;
  grid-template-columns: 135px auto;
  grid-column-gap: 10px;
`

export const Strong = styled.strong`
  font-weight: bold;
`
